import { useQuery } from "@tanstack/react-query";

import { CUSTOMER_QUERY_KEYS } from "common/constants";
import { useAuth } from "common/context/AuthContext";
import { get } from "common/helpers/HTTP";
import type { Invitation } from "common/types";

async function getInvitationsRequest(): Promise<Invitation[]> {
  return (await get("invites")).invites;
}

export default function useInvitations() {
  const { isAuthorized } = useAuth();

  const { data: invitations, isPending: isLoadingInvitations } = useQuery({
    queryKey: CUSTOMER_QUERY_KEYS.invitationsKeys.base,
    queryFn: getInvitationsRequest,
    enabled: !!isAuthorized,
  });

  return {
    invitations,
    isLoadingInvitations,
  };
}
